<template>
    <ElevatedCard class="container-widget" :widthType="WidthType.third">
        <HeaderWidget :title="widget.libelle"
                      :iconUrl="loadIcon"
                      :mode-edition='true'
                      @filtre='filtre'
                      @dupliquer='dupliquer'
                      @suppression='suppression' />
        <div>
            <span v-if='widget.site == null || widget.sites.length > 1' class='site-widget'>{{$t('multisites')}}</span>
            <span v-else v-for='site in widget.sites' :key='site.id' class='site-widget'>
                {{site.description}}
                <span v-if='site.id !== widget.sites[widget.sites.length - 1].id'>, </span>
            </span>
        </div>
        <div class="container-tiles">
            <Tile
                class="tile"
                :value="1"
                color="--edition-clair"
                :titleNotBold="$tc('estimateWidget.estimate')"
                :titleInBold="$t('estimateWidget.toValidate')"
                :is-loading='false'
            />
            <Tile
                class="tile"
                :value="2"
                color="--edition-medium"
                :titleNotBold="$t('estimateWidget.estimate')"
                :titleInBold="$t('estimateWidget.awaitingRealization')"
                :is-loading='false'
            />
            <Tile
                class="tile"
                :value="3"
                color="--edition-fonce"
                :titleNotBold="$t('estimateWidget.estimate')"
                :titleInBold="$tc('estimateWidget.inProgress', 3)"
                :is-loading='false'
            />
        </div>
    </ElevatedCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import ElevatedCard, { WidthType } from '@/components/ui-components/ElevatedCard.vue';
import HeaderWidget from '@/components/ui-components/HeaderWidget.vue';
import Tile from '@/components/ui-components/Tile.vue';
import { EtatDevis } from '@/models/Devis';
import { Widget } from '@/models/Widget';

export default defineComponent({
    name: 'EditionEstimate',
    components: { ElevatedCard, HeaderWidget, Tile },
    props: {
        widget:{ type: Object as PropType<Widget>, required: true },
    },
    setup() {
        return {
            WidthType,
            EtatDevis,
        };
    },
    computed: {
        loadIcon() {
            return require('@/assets/img/menu/calculate_45.png');
        },
    },
    methods: {
        filtre() {
            this.$emit('filtre');
        },
        dupliquer() {
            this.$emit('dupliquer');
        },
        suppression() {
            this.$emit('suppression');
        },
    },
});
</script>

<style scoped>
.container-tiles {
    padding: 10px 10px 8%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-grow: 1;
    gap: 25px;
    align-items: center;
    width: 86%;
    margin-left: auto;
    margin-right: auto;
}
@media screen and (max-width: 1600px) {
    .container-tiles {
        gap: 15px;
        width: 95%;
    }
}
.container-widget {
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    width: 33%;
}
.tile {
    margin: 5px 0;
    cursor: pointer;
    height: 120px;
    max-height: 20vh;
}
</style>
